<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M10.5,782.5l-1.9,4.76l-1.9,2.86H5.74l-1.52,2.29l0.57,0.57h0.95v7.62l-0.95,1.91l-2.86-4.76v-0.95l-0.57-0.57l-1.33,0.57
	l-1.45-0.83l3.99-4.56v-0.95H1.61l-4.56,3.99l-0.83-1.46l0.57-1.33l-0.57-0.57h-0.95l-4.76-2.86l1.9-0.95h7.62v0.95l0.57,0.57
	l2.29-1.52v-0.95l2.86-1.9L10.5,782.5L10.5,782.5z M-5.69,796.79h1.9v1.9l-4.76,2.86L-5.69,796.79L-5.69,796.79z"/>
</svg>

</template>